// extracted by mini-css-extract-plugin
export var content = "Sidebar-module--content--725d9";
export var contentCard = "Sidebar-module--content-card--9a82f";
export var image = "Sidebar-module--image--219cb";
export var sidebar = "Sidebar-module--sidebar--6a3e3";
export var white = "Sidebar-module--white--2547d";